import { render, staticRenderFns } from "./BemaniCodec.vue?vue&type=template&id=3187f8c6&scoped=true&"
import script from "./BemaniCodec.vue?vue&type=script&lang=js&"
export * from "./BemaniCodec.vue?vue&type=script&lang=js&"
import style0 from "./BemaniCodec.vue?vue&type=style&index=0&id=3187f8c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3187f8c6",
  null
  
)

export default component.exports